import { render, staticRenderFns } from "./GalleryVertical.vue?vue&type=template&id=935cef1c&"
import script from "./GalleryVertical.vue?vue&type=script&lang=js&"
export * from "./GalleryVertical.vue?vue&type=script&lang=js&"
import style0 from "./GalleryVertical.vue?vue&type=style&index=0&id=935cef1c&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('935cef1c')) {
      api.createRecord('935cef1c', component.options)
    } else {
      api.reload('935cef1c', component.options)
    }
    module.hot.accept("./GalleryVertical.vue?vue&type=template&id=935cef1c&", function () {
      api.rerender('935cef1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/product/gallery/GalleryVertical.vue"
export default component.exports